/**
 * 测量点分类分组的统一管理
 */
const measuringClassification = {
  createMeasureClass: "/api/createMeasureClass", //创建测量点分类
  modifyMeasureClass: "/api/modifyMeasureClass", //修改测量点分类
  deleteMeasureClass: "/api/deleteMeasureClass", //删除测量点分类
  getMeasureClass: "/api/getMeasureClass", //查询测量点分类
  getMeasureClasses2: "/api/getMeasureClasses2", //查询测量点分类
  addMeasureGroup: "/api/addMeasureGroup", //新增测量点分类分组
  modifyMeasureGroup: "/api/modifyMeasureGroup", //修改测量点分类分组
  deleteMeasureGroup: "/api/deleteMeasureGroup", //删除测量点分类分组
  getMeasureGroup: "/api/getMeasureGroup", //查询测量点分类分组
  getMeasureGroup2: "/api/getMeasureGroup2", //查询测量点分类分组
  setMeasuresInGroup: "/api/setMeasuresInGroup", //设置测量点到组
  removeMeasuresFromGroup: "/api/removeMeasuresFromGroup", //从组移除测量点
  getIntersectingMeasuresFromClass: "/api/getIntersectingMeasuresFromClass", //从组查询交集测量点
  getClassesOfMeasures: "/api/getClassesOfMeasures", //查询计量点分类分组信息
  getMeasuresFromGroup2: "/api/getMeasuresFromGroup2", //从组中查询测量点
  getMeasuresFromGroup: "/api/getMeasuresFromGroup", //从组中查询测量点
  getMeasureGroup4: "/api/getMeasureGroup4", //查询分类分组
};

export default measuringClassification;
